// utils/storage.ts

type StorageType = "local" | "session";

const storage = {
  set<T>(key: string, value: T, type: StorageType = "local") {
    const json = JSON.stringify(value);
    type === "local"
      ? localStorage.setItem(key, json)
      : sessionStorage.setItem(key, json);
  },

  get<T>(key: string, type: StorageType = "local"): T | null {
    const data =
      type === "local"
        ? localStorage.getItem(key)
        : sessionStorage.getItem(key);

    if (!data) return null;

    try {
      return JSON.parse(data) as T;
    } catch {
      return null;
    }
  },

  remove(key: string, type: StorageType = "local") {
    type === "local"
      ? localStorage.removeItem(key)
      : sessionStorage.removeItem(key);
  },

  clear(type: StorageType = "local") {
    type === "local" ? localStorage.clear() : sessionStorage.clear();
  },
};

export default storage;
